<template>
  <v-card elevation="0">
    <v-row v-if="setting_data && $route.params.id" cols="12" sm="12" md="12" lg="12" class="pb-0 mb-3">
      <v-col cols="12" class="pb-0">
        <v-card
          class="mt-0 pt-2 pb-0 pl-0 white--text"
          :class="{
            draft: setting_data.status === 'draft',
            release: setting_data.status === 'running',
            end: setting_data.status === 'disable',
          }"
        >
          <v-card-title class="pl-3 pt-0 pb-2 text-subtile2 d-flex justify-space-between">
            <template v-if="setting_data.status === 'draft'">
              <p class="ma-0">
                <v-icon color="white" class="mr-3"> mdi-timer-outline </v-icon>
                未發布(不會顯示)
              </p>
              <v-btn class="draft--text" color="white" @click="release()">
                <v-icon left color="draft"> mdi-play-circle-outline </v-icon>
                發布
              </v-btn>
            </template>

            <template v-if="setting_data.status === 'running'">
              <p class="ma-0">
                <v-icon color="white" class="mr-3"> mdi-timer-outline </v-icon>
                發布中(顯示)
              </p>
              <v-btn class="release--text" color="white" @click="stop()">
                <v-icon left color="release"> mdi-stop-circle-outline </v-icon>
                停止
              </v-btn>
            </template>

            <template v-else-if="setting_data.status === 'disable'">
              <p class="ma-0">
                <v-icon color="white" class="mr-3"> mdi-check-circle-outline </v-icon>
                已結束
              </p>
              <v-btn class="end--text" color="white" @click="stop">
                <v-icon left color="end"> mdi-chevron-left </v-icon>
                返回草稿
              </v-btn>
            </template>
          </v-card-title>
          <v-card-text
            class="pt-1 pb-1 pl-4 pr-0 text-subtitle-1 d-flex white--text"
            :class="{
              'orange darken-2': setting_data.status === 'draft',
              'green darken-2': setting_data.status === 'running',
              'grey darken-2': setting_data.status === 'disable',
            }"
          >
            <v-row>
              <v-col cols="12" xs="12" md="6" lg="6">
                <p class="pb-0 mb-0">
                  {{ `開始: ${$utils.displayISOString(config.start_at.value)}` }}
                </p>
              </v-col>
              <v-col cols="12" xs="12" md="6" lg="6">
                <p class="pb-0 mb-0">
                  {{ `結束: ${$utils.displayISOString(config.end_at.value)}` }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-card :key="`b_${setting_key}`">
      <v-card-title class="pb-1 text_primary">
        基本設定

        <v-spacer></v-spacer>

        <v-btn v-if="!is_edit" class="text_default btn_default btn_default_bg_linear" outlined @click="startEdit">
          編輯條件
        </v-btn>

        <v-btn
          v-if="!is_edit"
          :color="$vuetify.theme.themes['dark']['warning']"
          class="ml-3 btn-danger"
          outlined
          @click="deleteSetting(setting_data.urlView)"
        >
          刪除
        </v-btn>

        <v-btn v-if="is_edit" class="text_default btn_default btn_default_bg_linear mr-3" outlined @click="cancelEdit">
          取消
        </v-btn>

        <v-btn v-if="is_edit" class="btn-primary" outlined @click="saveEdit()"> 保存 </v-btn>
      </v-card-title>

      <div v-if="is_duplicate" class="mb-2 pt-4 pb-0 pl-6 pr-6">
        <v-alert outlined type="warning" prominent border="left">
          偵測到此頁面有啟用中的實驗/插件，請調整時間區間避免和以下實驗/插件衝突
        </v-alert>

        <div v-for="(settings, setting_key) in duplicate_setting" :key="setting_key" class="mb-2">
          <h3 v-if="settings.length > 0" class="mb-2 pb-0">{{ setting_key_map[setting_key].name }}:</h3>
          <v-card v-if="settings.length > 0">
            <v-data-table
              :headers="setting_key_map[setting_key].headers"
              :items="settings"
              hide-default-footer
              :items-per-page="settings.length"
            >
              <template #[`item.name`]="{ item }">
                <div
                  class="table-row-pointer table-truncate"
                  @click="viewInfo(item, setting_key, item[setting_key_map[setting_key].field_map.id])"
                >
                  {{ item.name }}
                </div>
              </template>
              <template #[`item.start_at`]="{ item }">
                {{ $utils.displayISOString(item.start_at) }}
              </template>
              <template #[`item.end_at`]="{ item }">
                {{ $utils.displayISOString(item.end_at) }}
              </template>
            </v-data-table>
          </v-card>
        </div>
      </div>

      <v-card-text eleavtion="0" class="pt-5">
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col cols="12" lg="12" md="12" xs="12" class="pb-0">
              <h5 class="subtitle-2 pa-0">
                {{ config.name.text }}
                <span class="error-message">(必填)</span>
              </h5>

              <v-text-field
                v-model="config.name.value"
                outlined
                dense
                class="pa-0 ma-0"
                :rules="[rules.required]"
                validate-on-blur
                :hint="'設定名稱，幫助你來辨認'"
                :disabled="!is_edit"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-0">
            <v-col cols="12" lg="12" md="12" xs="12" class="pt-0 pb-0">
              <h5 class="subtitle-2 pa-0">
                {{ config.url.text }}
                <span class="error-message">(必填)</span>
              </h5>
              <v-text-field
                v-model="config.url.value"
                outlined
                dense
                class="pa-0 ma-0"
                :rules="[rules.required, rules.validateUrl]"
                validate-on-blur
                :hint="'在哪個網址要顯示，例如: https://www.example.com/products/product_a'"
                :disabled="!is_edit"
                @blur="decodeURL"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="mt-0">
          <v-col cols="12" lg="6" md="6" xs="6" class="pt-0 pb-0">
            <h5 class="subtitle-2 pa-0">
              {{ config.start_at.text }}
              <span class="error-message">(必填)</span>
            </h5>
            <div>
              <date-picker
                v-model="config.start_at.value"
                :shortcuts="$utils.date_picker_shorcuts"
                class="date-picker"
                :class="{
                  'error-message': !config.start_at.value || config.start_at.message !== '',
                }"
                style="width: 100%"
                type="datetime"
                value-type="format"
                format="YYYY-MM-DD HH:mm:ss"
                :disabled="!is_edit"
                @click="config.start_at.message = ''"
              >
              </date-picker>
              <div>
                <small class="error-message pl-3">{{ config.start_at.message }}</small>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" md="6" xs="6" class="pt-0 pb-0">
            <h5 class="subtitle-2 pa-0">
              {{ config.end_at.text }}
              <span class="error-message">(必填)</span>
            </h5>
            <div>
              <date-picker
                v-model="config.end_at.value"
                :shortcuts="$utils.date_picker_shorcuts"
                class="date-picker"
                :class="{
                  'error-message': !config.end_at.value || config.end_at.message !== '',
                }"
                :disabled-date="disableEndtAt"
                style="width: 100%"
                type="datetime"
                value-type="format"
                format="YYYY-MM-DD HH:mm:ss"
                :disabled="!is_edit"
                @click="config.end_at.message = ''"
              >
              </date-picker>
              <div>
                <small class="error-message pl-3">{{ config.end_at.message }}</small>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card :key="setting_key" class="mt-5 pb-4">
      <v-card-title class="pb-4 text_primary">
        衝動外掛設定
        <v-spacer></v-spacer>

        <v-btn class="btn-primary ml-3" outlined @click="preivewPlugin(config)"> 查看結果 </v-btn>
      </v-card-title>

      <v-card-text>
        <v-card>
          <v-data-table
            ref="table"
            :headers="headers"
            :items="items"
            hide-default-footer
            :items-per-page="items.length"
          >
            <template #header.name="{ header }">
              <div class="d-flex align-center">
                {{ header.text }}
              </div>
            </template>

            <template #header.desktop="{ header }">
              <div
                class="d-flex align-center justify-center"
                :class="{
                  column_hover: header.high_light,
                }"
                style="height: 100%"
                @mouseenter="hoverHeader(header.value)"
                @mouseleave="leaveHeader(header.value)"
              >
                <div class="d-flex align-center justify-center" @click="editPlugin($route.params.id, header.value)">
                  <span class="mr-1">{{ header.text }}</span>
                  <v-icon small>mdi-pencil</v-icon>
                </div>
              </div>
            </template>

            <template #header.mobile="{ header }">
              <div
                class="d-flex align-center justify-center"
                :class="{
                  column_hover: header.high_light,
                }"
                style="height: 100%"
                @mouseenter="hoverHeader(header.value)"
                @mouseleave="leaveHeader(header.value)"
              >
                <div class="d-flex align-center justify-center" @click="editPlugin($route.params.id, header.value)">
                  <span class="mr-1">{{ header.text }}</span>
                  <v-icon small>mdi-pencil</v-icon>
                </div>
              </div>
            </template>

            <template #header.tablet="{ header }">
              <div
                class="d-flex align-center justify-center"
                :class="{
                  column_hover: header.high_light,
                }"
                style="height: 100%"
                @mouseenter="hoverHeader(header.value)"
                @mouseleave="leaveHeader(header.value)"
              >
                <div class="d-flex align-center justify-center" @click="editPlugin($route.params.id, header.value)">
                  <span class="mr-1">{{ header.text }}</span>
                  <v-icon small>mdi-pencil</v-icon>
                </div>
              </div>
            </template>

            <template #[`item.desktop`]="{ item }">
              <div
                style="height: 100%; cursor: pointer"
                :class="{
                  column_hover: item.high_light === 'desktop',
                }"
                class="d-flex align-center justify-center"
                @click="editPlugin($route.params.id, 'desktop')"
                @mouseenter="hoverHeader('desktop')"
                @mouseleave="leaveHeader('desktop')"
              >
                <span v-if="item.desktop !== 0">{{ item.desktop }}</span>
                <span v-else>未設定</span>
              </div>
            </template>

            <template #[`item.tablet`]="{ item }">
              <div
                style="height: 100%; cursor: pointer"
                class="d-flex align-center justify-center"
                :class="{
                  column_hover: item.high_light === 'tablet',
                }"
                @click="editPlugin($route.params.id, 'tablet')"
                @mouseenter="hoverHeader('tablet')"
                @mouseleave="leaveHeader('tablet')"
              >
                <span v-if="item.tablet !== 0">{{ item.tablet }}</span>
                <span v-else>未設定</span>
              </div>
            </template>

            <template #[`item.mobile`]="{ item }">
              <div
                :class="{
                  column_hover: item.high_light === 'mobile',
                }"
                class="d-flex align-center justify-center"
                style="height: 100%; cursor: pointer"
                @click="editPlugin($route.params.id, 'mobile')"
                @mouseenter="hoverHeader('mobile')"
                @mouseleave="leaveHeader('mobile')"
              >
                <span v-if="item.mobile !== 0">{{ item.mobile }}</span>
                <span v-else>未設定</span>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>

    <v-dialog v-if="preview_dialog.is_show" v-model="preview_dialog.is_show" width="600">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ preview_dialog.title }}
        </v-card-title>
        <v-card-text class="pb-3 mt-2 mb-0">
          <div>開始顯示時間: {{ config.start_at.value }}</div>
          <div>結束顯示時間: {{ config.end_at.value }}</div>
        </v-card-text>

        <v-card-text class="pb-3 pt-0 mt-0">
          <v-card-subtitle class="mb-0 pb-0 pl-0 mt-0 pt-0">模擬視窗大小: </v-card-subtitle>
          <v-select
            v-model="preview_dialog.selected_mode"
            class="pt-1"
            outlined
            :items="preview_dialog.mode_items"
            hide-details
            dense
            return-object
          >
          </v-select>
        </v-card-text>
        <!-- <v-card-text
                  class="pb-0"
                >
                  <v-card-subtitle class="mb-0 pb-0 pl-0">時間: </v-card-subtitle>
                  <v-radio-group
                    class="pt-1 mt-0 pb-2"
                    dense
                    v-model="preview_dialog.row"
                    row
                    hide-details
                  >
                    <v-radio
                      dense
                      label="當下時間"
                      value="by_now"
                    ></v-radio>
                    <v-radio
                        dense
                        label="指定時間(預覽用)"
                        value="by_time"
                    ></v-radio>
                </v-radio-group>
              </v-card-text> -->

        <v-card-text v-if="preview_dialog.row === 'by_time'">
          <date-picker
            v-model="preview_dialog.selected_time"
            :shortcuts="$utils.date_picker_shorcuts"
            style="width: 100%"
            type="datetime"
            value-type="format"
            format="YYYY-MM-DD HH:mm"
            class="date-picker"
          >
          </date-picker>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closePreview"> 關閉 </v-btn>
          <v-btn color="primary" text @click="confirmPreview"> 查看 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  apiGetOneSetting,
  apiUpdateSetting,
  apiOverlaySetting,
  apiGetPreviewToken,
  apiDisableUrlView,
  apiEnableUrlView,
  apiDeleteSetting,
} from '@/api/urlview.js'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw'
// import BasicSetting from './Steps/BasicSetting.vue'
// import FeatureSetting from './Steps/FeatureSetting.vue'
// import StyleSetting from './Steps/StyleSetting.vue'
// import StepperTimeline from '@/components/Utils/StepperTimeline.vue'
// import Step3 from '@/views/OptimizePage/SaleCounter/Steps/Step3.vue'
export default {
  name: 'PluginEdit',
  components: {
    DatePicker,
    // BasicSetting,
    // FeatureSetting,
    // StyleSetting,
    // StepperTimeline,
    // Step3
  },
  data: function () {
    return {
      is_edit: false,
      headers: [
        { text: '外掛', value: 'name', sortable: false },
        { text: '桌機', value: 'desktop', sortable: false, align: 'center' },
        { text: '平板', value: 'tablet', sortable: false, align: 'center' },
        { text: '手機', value: 'mobile', sortable: false, align: 'center' },
        { text: '', value: 'actions', sortable: false },
      ],
      items: [],
      devices: [
        {
          id: 'desktop',
          name: '桌機',
          icon: 'mdi-monitor',
        },
        {
          id: 'tablet',
          name: '平板',
          icon: 'mdi-tablet',
        },
        {
          id: 'mobile',
          name: '手機',
          icon: 'mdi-cellphone',
        },
      ],
      setting_data: null,
      copy_config: {},
      config: {
        name: {
          text: '名稱',
          value: '',
          copy: '',
        },
        url: {
          text: '網址',
          value: '',
          copy: '',
        },
        start_at: {
          text: '開始顯示時間',
          value: '',
          message: '',
          copy: '',
        },
        end_at: {
          text: '結束顯示時間',
          value: '',
          message: '',
          copy: '',
        },
        campaign_start_at: {
          text: '活動開始時間',
          value: '',
          message: '',
          copy: '',
        },
        campaign_end_at: {
          text: '活動結束時間',
          value: '',
          message: '',
          copy: '',
        },
        refererUrl: {
          value: '',
          message: '',
          copy: '',
        },
        add_column: {
          value: '',
          message: '',
          copy: '',
        },
      },
      rules: this.$utils.field_rules,
      same_checkbox: false,
      is_duplicate: false,
      duplicate_setting: {
        experience: [],
        urlview: [],
      },
      setting_key_map: {
        experience: {
          name: '實驗',
          headers: [
            { text: '名稱', value: 'name', sortable: false },
            { text: '開始時間', value: 'start_at', sortable: false },
            { text: '結束時間', value: 'end_at', sortable: false },
          ],
          field_map: {
            id: 'experience_id',
            name: 'name',
          },
        },
        urlview: {
          name: '插件',
          headers: [
            { text: '名稱', value: 'name', sortable: false },
            { text: '開始時間', value: 'start_at', sortable: false },
            { text: '結束時間', value: 'end_at', sortable: false },
          ],
          field_map: {
            id: 'id',
            name: 'name',
          },
        },
      },
      plugin: {
        sales_counter: {
          is_edit: false,
          init: {
            cal_type: '+',
            multiple: '1',
            init: 80,
            loop: true,
            repeat_from: 50,
            top: 100,
            add_col: '',
          },
          setting: null,
        },
        online_user: {
          is_edit: false,
          init: {
            bot: 10,
            top: 100,
            add_column: '',
          },
          setting: null,
        },
      },
      plugin_name: {
        sales_counter: '銷售計數器',
        online_user: '在線人數',
      },
      preview_dialog: {
        copy_setting: null,
        setting: null,
        row: 'by_now',
        title: '預覽衝動外掛',
        is_show: false,
        selected_mode: {
          text: '桌機',
          value: 'desktop',
          width: '',
        },
        selected_time: '',
        copy_mode_items: [],
        mode_items: [
          {
            text: '桌機',
            value: 'desktop',
            width: '',
          },
          {
            text: '平板',
            value: 'tablet',
            width: 768,
          },
          {
            text: '手機',
            value: 'mobile',
            width: 375,
          },
        ],
      },
      setting_key: 0,
      t_key: 0,
    }
  },
  computed: {},
  watch: {},
  created: async function () {
    await this.getData()
    await this.saveEdit(true)
  },
  mounted: function () {},
  methods: {
    async getData() {
      try {
        let result = await apiGetOneSetting(this.$route.params.org_id, this.$route.params.id)
        console.log('result:', result)

        let data = result.data
        this.setting_data = data
        let that = this
        Object.keys(this.config).forEach(function (field_key) {
          if (field_key.includes('at')) {
            that.config[field_key].value = that.$utils.displayISOString(data.urlView[field_key])
          } else {
            that.config[field_key].value = data.urlView[field_key]
          }
        })
        console.log(this.config)

        this.copy_config = JSON.parse(JSON.stringify(this.config))

        // 設定麵包屑
        this.$store.commit('update_breadcrumbs', [
          {
            text: '衝動外掛',
            disabled: false,
            href: `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/page_plugin/`,
          },
          {
            text: result.data.urlView.name,
          },
        ])

        this.initPlugin(data)
        this.setting_key += 1
      } catch (error) {
        console.log(error)
        this.$root.vtoast.show({
          message: `取得設定檔失敗，原因: ${error}`,
        })
        this.$router.go(-1)
      }
    },
    disableEndtAt(date) {
      let tmp_start_at = this.config.start_at.value
      if (tmp_start_at) {
        tmp_start_at = tmp_start_at.replace(/-/g, '/')
        let start_at = new Date(tmp_start_at)
        return date < start_at
      }
    },
    startEdit() {
      this.is_edit = true
    },
    cancelEdit() {
      this.is_edit = false
      this.config = JSON.parse(JSON.stringify(this.copy_config))
    },
    async saveEdit(is_check) {
      // 驗證欄位
      let result = this.$refs.form.validate()
      console.log(result)

      // 驗證時間
      let checks = []
      if (!this.config.start_at.value) {
        this.config.start_at.message = '必填欄位'
        checks.push(false)
      } else {
        this.config.start_at.message = ''
      }
      if (!this.config.end_at.value) {
        this.config.end_at.message = '必填欄位'
        checks.push(false)
      } else {
        this.config.end_at.message = ''
      }
      if (this.config.start_at.value && this.config.end_at.value) {
        let time1 = new Date(this.config.start_at.value).getTime()
        let time2 = new Date(this.config.end_at.value).getTime()
        if (time1 > time2) {
          this.config.end_at.message = '結束時間不能比開始時間早'
          checks.push(false)
        }
      }

      if (result === false || checks.includes(false)) {
        this.$root.vtoast.show({
          message: '請填寫完必填的欄位，再進行保存',
        })
        return
      }

      // 檢查是否有重複的urlview設定 + 實驗設定檔
      let is_duplicate = true
      let start_at = ''
      let end_at = ''
      try {
        let that = this
        start_at = this.$utils.toIsoString(this.config.start_at.value)
        end_at = this.$utils.toIsoString(this.config.end_at.value)
        let params = {
          start_at: start_at,
          end_at: end_at,
          container_id: this.$route.params.container_id,
          url: decodeURIComponent(decodeURIComponent(this.config.url.value)),
        }

        let check = await apiOverlaySetting(this.$route.params.org_id, params)
        console.log('check:', check)
        if (check.data.experience.length <= 0) {
          is_duplicate = false
        }
        console.log('is_duplicate1', is_duplicate)

        if (!is_duplicate) {
          for (let idx = 0; idx < check.data.urlview.length; idx++) {
            let target_setting = check.data.urlview[idx]
            if (target_setting.id !== parseInt(this.$route.params.id)) {
              is_duplicate = true
              break
            }
            is_duplicate = false
          }
        }
        console.log('is_duplicate2', is_duplicate)

        check.data.urlview = check.data.urlview.filter(function (url_view) {
          return url_view.id !== parseInt(that.$route.params.id)
        })

        this.duplicate_setting['urlview'] = check.data.urlview
        this.duplicate_setting['experience'] = check.data.experience
      } catch (error) {
        this.$root.vtoast.show({
          message: `檢查設定檔重複失敗，原因: ${error}`,
        })
      }
      this.is_duplicate = is_duplicate
      console.log('this.is_duplicate', this.is_duplicate)
      if (this.is_duplicate) {
        return
      }
      console.log('is_check', is_check)
      if (is_check) {
        return
      }
      console.log('pass', this.config)
      let params = {
        setting: {
          url: decodeURIComponent(decodeURIComponent(this.config.url.value)),
          name: this.config.name.value,
          container_id: this.$route.params.container_id,
          start_at: start_at,
          end_at: end_at,
          campaign_start_at: start_at,
          campaign_end_at: end_at,
          add_column: this.config.add_column.value,
          is_referer: this.config.refererUrl.value,
        },
      }
      try {
        let result = await apiUpdateSetting(this.$route.params.org_id, this.$route.params.id, params)
        console.log('result:', result)
        let data = result.data

        let that = this
        Object.keys(this.config).forEach(function (field_key) {
          if (field_key.includes('at')) {
            that.config[field_key].value = that.$utils.displayISOString(data.urlView[field_key])
          } else {
            that.config[field_key].value = data.urlView[field_key]
          }
        })
        console.log(this.config)
        this.copy_config = JSON.parse(JSON.stringify(this.config))

        this.$root.vtoast.show({
          message: `更新插件頁面條件成功`,
          color: 'primary',
        })
      } catch (error) {
        this.$root.vtoast.show({
          message: `新增設定檔失敗，原因: ${error}`,
        })
      }

      this.is_edit = false
    },
    viewInfo(item, type, id) {
      console.log('item', item)
      console.log('type', type)
      console.log('id', id)
      let path = ''
      if (type === 'experience') {
        path = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/experiments/${id}`
        console.log(path)
      } else {
        path = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/page_plugin/${id}`
        console.log(path)
      }
      if (path) {
        window.open(path, '_blank')
      }
    },
    initPlugin(data) {
      console.log('init_plugin', data)
      let that = this
      let plugin_types = Object.keys(this.plugin)
      that.items = []
      plugin_types.forEach(function (plugin_type) {
        that.plugin[plugin_type] = []
        that.plugin[plugin_type] = data[plugin_type]

        let tmp_item = {
          name: that.plugin_name[plugin_type],
        }
        that.devices.forEach(function (device) {
          let device_plugins = that.getDevicePlugin(that.plugin[plugin_type], device.id)
          tmp_item[device.id] = device_plugins
        })
        that.items.push(tmp_item)
      })
      console.log('that.plugin', that.plugin)
    },
    editPlugin(setting_id, header_type) {
      if (this.is_duplicate) {
        this.$root.vtoast.show({
          message: `無法編輯，原因: 請先調整衝突的實驗/插件，再繼續進行編輯。`,
        })
        return
      }

      let edit_path = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/page_plugin/page_editor/${setting_id}?device_type=${header_type}`
      this.$router.push(edit_path)
    },
    getDevicePlugin(plugins, device_type) {
      let filter_plugins = plugins.filter(function (plugin) {
        let add_col = JSON.parse(plugin.add_column)
        return add_col.device_type === device_type
      })
      return filter_plugins.length
    },
    preivewPlugin(config) {
      console.log('config', config)
      this.preview_dialog.is_show = true
    },
    closePreview() {
      console.log('close')
      this.preview_dialog.is_show = false
    },
    async confirmPreview() {
      console.log('preview', this.preview_dialog)
      if (this.preview_dialog.row === 'by_time' && !this.preview_dialog.selected_time) {
        return
      }
      let now = new Date().toISOString()
      console.log('now', now)
      let specific_time = this.$utils.toIsoString(now)
      console.log('1', specific_time)
      if (this.preview_dialog.row === 'by_time') {
        specific_time = this.$utils.toIsoString(this.preview_dialog.selected_time)
      }
      console.log('specific_time', specific_time)

      try {
        let token = await apiGetPreviewToken(
          this.$route.params.org_id,
          this.$route.params.container_id,
          this.$route.params.id
        )
        console.log('token', token)
        let url = new URL(this.config.url.value)
        url.searchParams.append('opt99_auth_token', token)
        url.searchParams.append('opt99_preview', this.$route.params.id)
        url.searchParams.append('opt99_preview_type', 'page_plugin')
        url.searchParams.append('opt99_c_id', this.$route.params.container_id)
        url.searchParams.append('opt99_target_time', specific_time)

        let height = window.screen.height
        let width = window.screen.width
        if (this.preview_dialog.selected_mode.width) {
          width = this.preview_dialog.selected_mode.width
        }
        console.log('width', width)
        console.log('height', height)
        let window_params = `width=${width},height=${height}`

        console.log('link:', url.href)
        this.$utils.openURL(url.href, window_params)
      } catch (error) {
        this.$root.vtoast.show({
          message: `預覽失敗，原因: ${error}`,
        })
      }
    },
    async release() {
      try {
        let result = await apiEnableUrlView(this.$route.params.org_id, this.$route.params.id)
        console.log('release:', result)
        this.$root.vtoast.show({
          message: `發布成功！`,
          color: 'primary',
        })
        await this.getData()
      } catch (error) {
        console.log('error', error)
        this.$root.vtoast.show({
          message: `發布失敗，原因: ${error}`,
        })
      }
    },
    async stop() {
      try {
        let result = await apiDisableUrlView(this.$route.params.org_id, this.$route.params.id)
        console.log('release:', result)
        this.$root.vtoast.show({
          message: `停止成功！`,
          color: 'primary',
        })
        await this.getData()
      } catch (error) {
        console.log('error', error)
        this.$root.vtoast.show({
          message: `停止失敗，原因: ${error}`,
        })
      }
    },
    hoverHeader(header_type) {
      console.log('hover', header_type)
      this.items.forEach(function (item) {
        item.high_light = header_type
      })
      this.headers.forEach(function (t_header) {
        t_header.high_light = false
        if (t_header.value === header_type) {
          t_header.high_light = true
        }
      })
      this.items = JSON.parse(JSON.stringify(this.items))
      console.log('items', this.items)
    },
    leaveHeader(header_type) {
      console.log('leaver', header_type)
      this.items.forEach(function (item) {
        item.high_light = ''
      })
      console.log('items', this.items)
      this.headers.forEach(function (t_header) {
        t_header.high_light = false
      })
      this.items = JSON.parse(JSON.stringify(this.items))
    },
    async deleteSetting(item) {
      let is_confirm = confirm(`確定刪除 ${item.name} 這個衝動外掛設定檔？`)
      if (!is_confirm) {
        return
      }
      try {
        let result = await apiDeleteSetting(this.$route.params.org_id, item.id)
        console.log('result', result)
        this.$root.vtoast.show({
          message: `刪除成功`,
        })
        this.$router.push(`/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/page_plugin/`)
      } catch (error) {
        this.$root.vtoast.show({
          message: `刪除設定檔失敗，原因: ${error}`,
        })
      }
    },
    decodeURL() {
      try {
        this.config.url.value = decodeURIComponent(decodeURIComponent(this.config.url.value))
        console.log('decode', this.config.url.value)
      } catch (error) {
        console.log('decode_url_error', error)
      }
    },
  },
}
</script>
<style scoped>
.error-message {
  color: #ff1744;
}
.date-picker >>> .mx-input {
  height: 40px;
}
.date-picker.error-message >>> .mx-input {
  border-color: #ff1744;
  border-width: 2px;
}
.column_hover {
  background-color: rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.v-data-table >>> tr:hover {
  background: transparent !important;
}
</style>
